import React from "react";
import { Container } from "react-bootstrap";
import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";

const GuidePage = ({ state }) => (
  <Layout
    title="Stride Equity - Financial Services Guide"
    meta={{
      card: "summary_large_image",
      description:
        "This Financial Services Guide (FSG) is designed to assist you in deciding whether to use any of the financial services offered by StrideCorp Equity Partners Pty Ltd (Stride Equity).",
    }}
    state={state}
  >
    <div className="offset-header financial-services-guide service-page">
      <Container className="pt-5 container-wrp">
        <h1 className="mb-3">Financial Services Guide</h1>
        <hr />
        <div className="service-content-wrapper">
          <p className="effectiveby">Effective: July 2022</p>
          <h3>
            StrideCorp Equity Partners Pty Ltd (ABN 49 607 216 928 AFSL No. 482
            668)
          </h3>
          <p className="mb-1">Issue Date: July 2022</p>
          <h3>Purpose and content of this FSG</h3>
          <p>
            This Financial Services Guide (FSG) is designed to assist you in
            deciding whether to use any of the financial services offered by
            StrideCorp Equity Partners Pty Ltd (<b>Stride Equity</b>). It
            provides you with an understanding of what to expect from your
            interactions with Stride Equity.
          </p>
          <p>This guide contains information about:</p>

          <ul>
            <li>
              Services provided by Stride Equity - the kinds of services Stride
              Equity is authorised to provide under its Australian Financial
              Services (AFS) licence;
            </li>
            <li>
              Remuneration received by Stride Equity, its staff and related
              persons in connection with the financial services Stride Equity
              provides; and
            </li>
            <li>
              Complaints Process - how Stride Equity deals with any complaints
              you may have about its services.
            </li>
          </ul>
          <h3>How to contact us</h3>
          <p>
            You can contact and find out more information about Stride Equity in
            the following ways:
          </p>
          <p>
            Email:{" "}
            <a href="mailto:info@strideequity.com.au">
              info@strideequity.com.au
            </a>
          </p>
          <p>Phone: 0414880987</p>

          <h3>
            Financial services we are licensed to provide and the financial
            products that these services relate to
          </h3>
          <p>
            Stride Equity is authorised to provide a crowdfunding service (as a
            CSF Intermediary) to retail and wholesale clients, for fully-paid
            ordinary shares of eligible CSF companies (<b>CSF Issuer</b>)
            published on our offer platform (<b>the Platform</b>), accessible at
            <a target="_blank" href="http://www.strideequity.com.au/">
              www.strideequity.com.au
            </a>{" "}
            (<b>the Website</b>).
          </p>
          <p>
            Stride Equity is authorised under its AFS licence to provide general
            financial product advice to retail and wholesale clients in relation
            to securities.
          </p>
          <p>
            Stride Equity does not provide personal advice. You should consider
            your own specific objectives, financial situation or needs and seek
            independent accounting, financial, taxation, and legal advice,
            before making any investment decision.
          </p>

          <h3>Gatekeeper obligations</h3>
          <p>
            A CSF Intermediary has certain specific obligations that apply in
            recognition of its important role as a ‘gatekeeper’ for the
            Platform, which include:
          </p>
          <ul>
            <li>
              Performing certain checks before publishing a CSF offer document
              on the Platform; and
            </li>
            <li>
              Not publishing, or not continuing to publish, a CSF offer document
              on the Platform in certain circumstances.
            </li>
          </ul>
          <p>
            Use of the Platform accessible via the Website is subject to the
            Hosting Agreement for CSF Issuers and the Investor Terms and
            Conditions.
          </p>
          <p>
            Offers of securities in the CSF Issuer (<b>CSF Offers</b>) and
            expressions of interest campaigns (<b>EOI campaigns</b>) are
            facilitated by Stride Equity via the Platform and involves the
            provision of a crowdfunding service.
          </p>
          {/* changed */}
          {/* <h3>Fees and charges</h3>
          <ol type="a">
            <li>
              <b>Administration and Campaign fees</b>: A fee of up to $4,000
              (plus GST) charged to CSF Issuer for services which includes due
              diligence, and work completed to launch the EOI campaign and CSF
              Offer.
            </li>
            <li>
              <b>Offer Success Fee</b>: Up to 7% (plus GST) of all funds raised
              by a CSF Issuer following the successful completion of a CSF offer
              as set out in clause 7.
            </li>
            <li>
              Stride Equity may also receive a success fee from CSF Issuers for
              funds raised from Investors introduced through the Stride Equity
              Platform who provide funds outside the Platform, and not under a
              CSF Offer on the Stride Equity platform, within 12 months of a CSF
              Offer.
            </li>
          </ol>
          <h3>Investor fees</h3>
          <p>
            We do not charge retail investors any fees for participating in
            retail Investment opportunities.
          </p> */}

          <h3>Issuer Fees (Retail and Wholesale offers)</h3>
          <ul>
            <li>
              <b>Administration and Campaign fees</b>:
              <section className="mt-1">
                A fee of up to $4,000 (plus GST) charged to a CSF Issuer for
                services which includes due diligence, and work completed to
                launch the Expression of Interest campaign and CSF Offer.{" "}
              </section>
              <section className="mt-1">
                An additional CSF Offer Administration Fee may be payable by the
                issuer to Stride Equity if:
                <ul type="circle">
                  <li>
                    an issuer requires a replacement or supplementary CSF Offer
                    Document to be published on the Platform; or
                  </li>
                  <li>
                    an issuer’s circumstances are complicated or unusual, for
                    example, where we are required to perform extensive
                    investigations to determine an Issuer’s eligibility (or its
                    directors or senior managers eligibility) to make a CSF
                    Offer.
                  </li>
                </ul>
              </section>
            </li>
            <li>
              <b>Offer Success Fee</b>:
              <section className="mt-1">
                Up to 7% (plus GST) of all funds raised by an Issuer following
                the successful completion of a CSF Offer.
              </section>
              <section className="mt-1">
                We may also receive a success fee from CSF Issuers for funds
                raised from Investors introduced through the Stride Equity
                platform who provide funds outside the platform, and not under a
                CSF Offer on the Stride Equity platform, within 12 months of a
                CSF Offer.
              </section>
            </li>
          </ul>
          <h3>Retail Offers</h3>
          <ul>
            <li>
              <section className="mt-1">
                Investors will not pay any fees to Stride Equity for applying
                for shares in a Retail Offer via Stride Equity, unless notified
                under the Investors
                <a href="/investor-terms-and-conditions" target="_blank">
                  {" "}
                  Terms and Conditions{" "}
                </a>
                or the terms of the Offer.
              </section>

              <section className="mt-1">
                Stride Equity may introduce fees by giving advance notice to
                subscribers.
              </section>
            </li>
          </ul>
          {/* changed */}

          <h3>Additional fees</h3>
          <p>
            An additional CSF Offer Administration Fee may be payable by the
            issuer to Stride Equity if:
          </p>
          <ul>
            <li>
              an issuer requires a replacement or supplementary CSF offer
              document to be published on the Platform; or
            </li>
            <li>
              an issuer’s circumstances are complicated or unusual, for example,
              where we are required to perform extensive investigations to
              determine its eligibility (or its directors or senior managers
              eligibility) to make a CSF Offer.
            </li>
          </ul>
          <p>
            Interest on funds held in trust will be retained by Stride Equity
            and not paid to CSF Issuers on completion, or to Investors if the
            Offer is unsuccessful.{" "}
          </p>
          <h3>Referral programs</h3>
          <p>
            From time to time Stride Equity may pay referral fees to third
            parties that introduce CSF Issuers or investors to the Platform.
            Referral fees may be calculated as either a percentage of the
            success fee to be received by Stride Equity on the amount raised
            under the relevant CSF Offer, the amount invested in a CSF Offer by
            an investor, or a flat fee.
          </p>

          <h2>Information for Investors and CSF Issuers</h2>
          <h3>Creating an account</h3>
          <p>
            You must create an account prior to accessing any of the services
            available on the Website. CSF Issuers and Investors can create an
            account by selecting the “Login” and "Register" button on the
            Website.
          </p>
          <p>
            To become a CSF Issuer the company applying will be asked to provide
            a pitch deck and additional documents and we will assess the
            application and notify the CSF Issuer regarding the outcome.{" "}
          </p>
          <p>
            Prior to making a CSF Offer on the Platform, the CSF Issuer must
            enter a Hosting Agreement, which sets out the arrangement with
            Stride Equity for the hosting of an EOI campaign, publication of a
            CSF Offer and the conduct of the CSF Offer on the Platform.
          </p>
          <p>
            By creating an account and using the Website, you agree to the
            Website Terms of Service (available at www.StrideEquity.com.au) as
            amended from time to time.
          </p>
          <h3>Expressing interest in EOI Campaigns</h3>
          <p>
            EOI Campaigns are a way for CSF Issuers to assess demand for a
            potential CSF Offer. All live EOI campaigns can be viewed on the
            Platform.
          </p>
          <p>
            Once you have created an account and logged-in, you can express your
            interest in an EOI campaign. By expressing your interest, you are
            making a non-binding indication of your interest to participate in
            the company's intended CSF Offer (if and when it proceeds).
            Submitting an expression of interest is not an investment, and does
            not create any obligations or rights.
          </p>

          <h3>Applying for shares under a CSF Offer</h3>
          <p>
            A CSF Offer is an offer for fully-paid ordinary shares in the CSF
            Issuer. A CSF Offer is made under a CSF Offer Document, which
            contains important information about the Issuer and the CSF Offer.{" "}
          </p>

          {/* not in the design */}

          <p>
            If you are considering investing via a CSF Offer, you should
            consider the CSF Offer Document carefully before investing. A CSF
            Offer Document includes the following important information:{" "}
          </p>
          <ul>
            <li>
              Risk warnings - A general risk warning about crowd-sourced funding
              (prescribed by law);
            </li>
            <li>Information about the company; </li>
            <li>Information about the offer;</li>
            <li>Information about investor rights.</li>
          </ul>
          <p>
            Applications for shares under a CSF offer hosted by Stride Equity
            can only be made via the application facility operated by Stride
            Equity on the Website. Once you have created an account and
            logged-in, you can apply for shares under a live CSF offer.
          </p>
          <h3>Paying for shares under a CSF Offer</h3>
          <p>
            In order to apply for shares under a CSF Offer, you must agree to
            the Investor Terms and Conditions that can be found on our website.
          </p>
          <p>
            All application money in relation to a CSF offer will be held on
            trust by Stride Equity in a designated client money account in
            accordance with Stride Equity obligations under the Corporations Act
            2001 (Cth).
          </p>
          <h3>Activities and events while a CSF Offer is open</h3>
          <p>
            Stride Equity will provide and administer a communications facility
            for the CSF Offer, where Platform users can ask questions of the
            Issuer.
          </p>
          <h3>Stride Equity will suspend a CSF Offer:</h3>
          <ul>
            <li>
              When it considers that the CSF Issuer has breached, or will be
              likely to breach, the terms of the Hosting Agreement;
            </li>
            <li>
              After becoming aware that the CSF offer document is defective,
              unless Stride Equity elects to close the CSF offer on becoming
              aware that the CSF offer document is defective;
            </li>
            <li>On a CSF Issuer’s request; and</li>
            <li>
              Where it considers that it must do so under relevant laws, or
              where a Regulator issues the relevant order to do so.
            </li>
          </ul>
          <h3>Stride Equity will close a CSF Offer:</h3>
          <ul>
            <li>When the maximum period for the CSF offer ceases;</li>
            <li>
              When the maximum offer amount has been reached, or the CSF offer
              is fully subscribed, and all applicant withdrawal rights have
              expired;
            </li>
            <li>
              When it considers that the CSF Issuer has breached, or will be
              likely to breach, the terms of the Hosting Agreement;
            </li>
            <li>
              After becoming aware that the CSF offer document is defective;
            </li>
            <li>
              In accordance with the closing date in the CSF offer document;
            </li>
            <li>On an Issuer’s request; and</li>
            <li>
              Where it considers that it must do so under relevant laws, or
              where a Regulator order to do so.
            </li>
          </ul>

          <h3>Return of funds </h3>
          <p>
            If a CSF Offer is unsuccessful (i.e. the minimum offer target has
            not been reached and the period for the CSF Offer has expired),
            Stride Equity will refund application money as soon as practicable
            after the CSF Offer is closed. No interest will be paid on the
            application money.
          </p>

          <h3>Issue of shares</h3>
          <p>
            Stride Equity will notify the CSF Issuer once an offer is complete.
            Stride Equity will provide the CSF Issuer with:
          </p>
          <ul>
            <li>
              details of all application money held in respect of a CSF Offer;
            </li>
            <li>details of all successful applicants under the CSF Offer</li>
            <li>instructions to issue shares.</li>
          </ul>
          <p>
            The CSF Issuer will be asked to confirm and provide evidence that it
            has complied with the terms of the CSF Offer, including, shares
            issued, and request for ASIC records to be updated.
          </p>
          <p>
            Stride Equity will then pay the Issuer the application money
            received in response to the CSF Offer, less any fees payable to
            Stride Equity as soon as practicable. No interest will be paid to a
            CSF Issuer for the time the application money was held by Stride
            Equity.
          </p>
          <h3>Cooling off rights</h3>
          <p>
            If you are an Investor, who is not classified as a sophisticated
            investor under S708 of the Corporations Act 2001, you may cancel an
            application in an Offer within 5 Business Days after applying (i.e.
            application money received) and any payments made will be refunded.
          </p>
          <h2>What happens if you want to make a complaint?</h2>
          <p>
            If you have a complaint about any of our services, Stride Equity has
            established complaint resolution procedures set out below:
          </p>
          <p>
            To raise concerns or provide feedback contact us directly. We will
            do our best to resolve any issues you may have quickly.
          </p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:info@strideequity.com.au">
                info@strideequity.com.au
              </a>
            </li>
            <li>Phone: 0414880987</li>
          </ul>

          <p>
            If you are unhappy with the response or you would like to escalate
            the matter, you can contact our Complaints Officer. Our Complaints
            Officer will attempt to resolve your concern quickly and amicably.
            We will update you regularly until the matter is resolved.
          </p>

          <ul>
            <li>
              Email:{" "}
              <a href="mailto:complaints@strideequity.com.au ">
                complaints@strideequity.com.au
              </a>
            </li>
            <li>Phone: 0405183147</li>
          </ul>

          <p>
            If you are not satisfied with the steps taken by Stride Equity to
            resolve the complaint, you can contact the Australian Financial
            Complaints Authority (AFCA).
          </p>
          <ul>
            <li>Email: info@afc.org.au</li>
            <li>Mail: GPO Box 3 Melbourne Vic 3001</li>
            <li>Web: www.afca.org.au</li>
            <li>Phone: 1800 931 678</li>
          </ul>

          <h2>Compensation Arrangements</h2>
          <p>
            Stride Equity has professional indemnity insurance in place which
            satisfies the requirements for compensation arrangements pursuant to
            s912B of the Corporations Act and ASIC policy guidance. This policy
            is subject to terms and exclusions and covers claims made against
            Stride Equity in relation to financial services provided by our
            current and former employees. Neither Stride Equity, nor any of its
            directors, authorised representatives, employees, or agents, makes
            any representation or warranty as to the reliability, accuracy, or
            completeness of any advice.
          </p>

          <h2>Further questions</h2>
          <p>
            If you have any further questions about the financial services which
            we provide, please contact us on{" "}
          </p>
          <a href="mailto:info@strideequity.com.au">info@strideequity.com.au</a>
        </div>
      </Container>
    </div>
  </Layout>
);

export async function getServerSideProps({ req, res }) {
  return {
    props: {
      state: await ServerProps.getState(req),
    },
  };
}

export default GuidePage;
